import React, { FC } from 'react'

import { NotificacaoTransacional } from 'pages/product-details/types/ProductDetails.types'

import { Text } from '@interco/inter-ui/components/Text'
import { Switch } from '@interco/inter-ui/components/Switch'

import { Container, HeaderContainer } from './styles'

export const TransactionalNotification: FC<NotificacaoTransacional> = ({ descricao, titulo }) => (
  <Container>
    <HeaderContainer>
      <Text variant="headline-h3" color="typography" colorWeight={500} semiBold as="p">
        {titulo}
      </Text>
      <Switch disabled checked />
    </HeaderContainer>
    <Text variant="body-3" color="typography" colorWeight={400} as="p">
      {descricao}
    </Text>
  </Container>
)
